/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { IconWithContentCardContent } from '../Shared/IconWithContentCardContent'
import { useTranslation } from 'react-i18next'

const NoImportStockCardContent = () => {
    const [t] = useTranslation()

    return (
      <IconWithContentCardContent
        iconElement={(
          <>
              <Icon color="grey" name="plug"/>
              <Icon corner name="ban" color="grey"/>
          </>
        )}
        contentElement={(
          <p
            css={css`
                margin-right: .5rem;
                font-weight: bold;
            `}>
              {t('import_stock.no_import_stock')}
          </p>
        )}
      />
    )
}

export { NoImportStockCardContent }
